exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#enrollButton[data-v-fad2d692] {\n  width: 70%;\n}\n.serviceList[data-v-fad2d692] {\n  text-decoration: underline;\n  color:black;\n  font-size: 12px;\n  color: blue;\n}\n.streammind-icon-pop-up[data-v-fad2d692] {\n  margin-left: auto !important;\n}\n\n/* TLV 28/11/2019 : Le menu \"MoneyRoad services\" sur PC est affiché autrement que sur mobile */\n@media (max-width:992px) {\n.menuChangeService[data-v-fad2d692] {\n    padding-top:15px;\n}\n}\n@media (min-width:992px) {\n.menuChangeService[data-v-fad2d692] {\n    padding-top:80px;\n}\n  /* TLV 09/03/2020 : Réglage de la hauteur des items du menu de changement de service */\n.menuIcon .menuItem[data-v-fad2d692] {\n    margin-top: 100px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fad2d692","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/popups/ServicesSwitcherPopup.vue
// module id = 1624
// module chunks = 2